import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { translate } from 'translations/translator';
import { getNewLink } from '../../../util/workbook-util';
import { useSelector } from 'react-redux';
import { AppStoreState } from 'types';
import { HwtButton } from 'components/@common/Buttons/HwtButton';

const getTranslation = key => translate('assignmentTracker', key);

export const AssignmentTrackerFooter = () => {
  const currentWorkbook: any = useSelector(({ app }: AppStoreState) => app.currentWorkbook);

  const { bookCode, edition } = useParams();
  const navigate = useNavigate();

  const handleBackToLessonPlanner = () => {
    navigate(getNewLink(bookCode ?? '', edition ?? '', 'lessonPlanner'));
  };

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        backgroundColor: currentWorkbook?.primaryColor ?? 'white',
        position: 'fixed',
        bottom: 0
      }}
    >
      <Box px={3} py={1}>
        <HwtButton
          style={{ width: 'auto', padding: '10px 15px' }}
          color="primary"
          variant="contained"
          startIcon={<ArrowBackIcon fontSize="small" />}
          onClick={handleBackToLessonPlanner}
        >
          {getTranslation('backToLessonPlanner')}
        </HwtButton>
      </Box>
    </Container>
  );
};
